import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  MenuItem,
  Box,
  Typography,
  Slide,
  FormControlLabel,
  Switch,
  TextField,
  Checkbox,
  Snackbar,
  Alert,
  Autocomplete,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import { addProduct, updateProduct } from "../../../Services/authService";
import { useThemeContext } from "../../../Context/ThemeContext";
import { DARKCOLORS, LIGHTCOLORS } from "../../../Utils/constants";
import SuccessNotification from "../../../Components/Common/SuccessNotification";
import { StyledTextField } from "../../../Components/Common/StyledTextField";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import LoadingAnimation from "../../../Components/Common/LoadingAnimation";
import useMediaQuery from "@mui/material/useMediaQuery";

// Slide Transition Function
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} timeout={800} />;
});

function ProductModal({
  open,
  categories,
  products,
  onClose,
  fetchProductsByCategory,
  selectedProduct,
  handleDeleteClick,
  onProductUpdated,
}) {
  const { t, i18n } = useTranslation();
  const { mode } = useThemeContext();

  const btnColor =
    mode === "dark" ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;
  const modalBackgrounColor =
    mode === "dark" ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard;
  const inputTextColor =
    mode === "dark"
      ? DARKCOLORS.BodyLightBackground
      : LIGHTCOLORS.BodyLightBackground;
  const inputBoxColor =
    mode === "dark" ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
  const imgBoxColor =
    mode === "dark" ? DARKCOLORS.GreyScale60 : LIGHTCOLORS.GreyScale60;
  const deleteColor =
    mode === "dark" ? DARKCOLORS.Danger500 : LIGHTCOLORS.Danger500;

  const counterNormalColor =
    mode === "dark" ? DARKCOLORS.GreyScale50 : "#9CA3AF";
  const counterWarningColor =
    mode === "dark" ? DARKCOLORS.Warning500 : LIGHTCOLORS.Warning500;
  const counterErrorColor =
    mode === "dark" ? DARKCOLORS.Danger500 : LIGHTCOLORS.Danger500;

  const scroll1 =
    mode === "light"
      ? LIGHTCOLORS.BodyDarkBackground
      : DARKCOLORS.BodyLightBackground;

  const scroll =
    mode === "light" ? LIGHTCOLORS.GreyScale40 : DARKCOLORS.GreyScale40;

  const tags = [
    { label: t("inventory.Vegetarian"), key: "vegetarian" },
    { label: t("inventory.Vegan"), key: "vegan" },
    { label: t("inventory.Fish"), key: "fishFree" },
    { label: t("inventory.Gluten"), key: "glutenFree" },
    { label: t("inventory.Lactose"), key: "lactoseFree" },
    { label: t("inventory.Protein"), key: "highProtein" },
    { label: t("inventory.Not-Specified"), key: "notSpecified" },
  ];

  const [formData, setFormData] = useState({
    name: "",
    category: "",
    description: "",
    price: "",
    heatOption: false,
    allergyInfo: "",
    tags: [],
  });
  const isMobile = useMediaQuery("(max-width:500px)");

  const NAME_MAX_LENGTH = 100;
  const DESCRIPTION_MAX_LENGTH = 1500;
  const NAME_WARN_THRESHOLD = 90;
  const DESC_WARN_THRESHOLD = 1350;

  const nameCharCount = (formData.name || "").length;
  const descCharCount = (formData.description || "").length;
  const isNameAtLimit = nameCharCount >= NAME_MAX_LENGTH;
  const isNameWarning =
    nameCharCount >= NAME_WARN_THRESHOLD && nameCharCount < NAME_MAX_LENGTH;
  const isDescAtLimit = descCharCount >= DESCRIPTION_MAX_LENGTH;
  const isDescWarning =
    descCharCount >= DESC_WARN_THRESHOLD &&
    descCharCount < DESCRIPTION_MAX_LENGTH;

  const [errors, setErrors] = useState({});
  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null); // File object for the image
  const [generalError, setGeneralError] = useState("");
  const [successNotification, setSuccessNotification] = useState(false);
  const [heatOption, setHeatOption] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [open1, setOpen1] = useState(false);
  const [dietaryPreferences, setDietaryPreferences] = useState({
    vegetarian: false,
    vegan: false,
    fishFree: false,
    glutenFree: false,
    lactoseFree: false,
    highProtein: false,
    notSpecified: false,
  });

  const categoryList = Array.isArray(categories)
    ? categories
    : Array.isArray(categories?.data)
      ? categories.data
      : [];

  const TAG_KEY_MAP = {
    Vegetarian: "vegetarian",
    Vegan: "vegan",
    "Fish-Free": "fishFree",
    "Gluten-Free": "glutenFree",
    "Lactose-Free": "lactoseFree",
    "High Protein": "highProtein",
    "Not Specified": "notSpecified",
  };
  const [imageError, setImageError] = useState(false);

  const handleToggleHeatOption = () => {
    setHeatOption(!heatOption);
  };

  // const handleDietaryPreferenceChange = (event) => {
  //     const { name, checked } = event.target;
  //     // Update dietary preferences state
  //     setDietaryPreferences(prevState => {
  //         const updatedDietaryPreferences = {
  //             ...prevState,
  //             [name]: checked
  //         };

  //         // Immediately update the formData.tags field with the selected tags using the updated preferences
  //         const selectedTags = tags
  //             .filter(tag => updatedDietaryPreferences[tag.label.toLowerCase().replace(' ', '')])  // Filter by selected preferences
  //             .map(tag => tag.label);  // Extract only labels

  //         console.log(selectedTags);

  //         setFormData(prevFormData => ({
  //             ...prevFormData,
  //             tags: selectedTags,  // Replace old tags with the new ones
  //         }));

  //         return updatedDietaryPreferences;
  //     })
  // };

  const handleDietaryPreferenceChange = (event) => {
    const { name, checked } = event.target;

    let updatedPreferences;
    if (name === "notSpecified") {
      if (checked) {
        updatedPreferences = {
          vegetarian: false,
          vegan: false,
          fishFree: false,
          glutenFree: false,
          lactoseFree: false,
          highProtein: false,
          notSpecified: true,
        };
      } else {
        updatedPreferences = { ...dietaryPreferences, notSpecified: false };
      }
    } else {
      updatedPreferences = {
        ...dietaryPreferences,
        [name]: checked,
        notSpecified: false,
      };
    }

    // Recalculate tags based on updated preferences
    const selectedTags = Object.entries(updatedPreferences)
      .filter(([_, value]) => value)
      .map(([key]) => {
        // Find label by matching key
        return Object.keys(TAG_KEY_MAP).find(
          (label) => TAG_KEY_MAP[label] === key,
        );
      })
      .filter(Boolean); // Remove undefined

    setFormData((prevFormData) => ({
      ...prevFormData,
      tags: selectedTags,
    }));

    setDietaryPreferences(updatedPreferences);
  };

  useEffect(() => {
    // Repopulate on every open: `handleClose` wipes the form, and the parent
    // keeps the same `selectedProduct` reference when the same product is
    // reopened, so depending on `selectedProduct` alone misses that case
    if (!open) return;
    setGeneralError("");
    setErrors({});
    if (selectedProduct) {
      setFormData({
        name: selectedProduct.productName,
        category: selectedProduct.category.id,
        description: selectedProduct.description,
        price: selectedProduct.actualPrice,
        heatOption: Boolean(selectedProduct.heatOption),
        heatTime: selectedProduct?.heatTime || "",
        allergyInfo: selectedProduct.allergyInfo,
        tags: selectedProduct.tags || [],
      });
      setImagePreview(selectedProduct.imageUrl || null);
      setHeatOption(Boolean(selectedProduct.heatOption));

      // Set dietary preferences based on selected product's tags
      // Build dietary preference state from selected product tags
      const preferencesFromTags = {};
      Object.keys(dietaryPreferences).forEach((key) => {
        // Find English label via TAG_KEY_MAP (reverse lookup) and check in selectedProduct.tags
        const englishLabel = Object.keys(TAG_KEY_MAP).find(
          (label) => TAG_KEY_MAP[label] === key,
        );
        preferencesFromTags[key] = selectedProduct.tags.includes(englishLabel);
      });
      setDietaryPreferences(preferencesFromTags);
    } else {
      setFormData({
        name: "",
        category: "",
        description: "",
        price: "",
        heatOption: false,
        heatTime: "",
        allergyInfo: "",
        tags: [],
      });
      setDietaryPreferences({
        vegetarian: false,
        vegan: false,
        fishFree: false,
        glutenFree: false,
        lactoseFree: false,
        highProtein: false,
        notSpecified: false,
      });
      setImagePreview(null);
      setHeatOption(false);
    }
  }, [selectedProduct, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
     if (name === "heatTime") {
    const numericValue = value.replace(/[^0-9]/g, "");

    setFormData({
      ...formData,
      heatTime: numericValue,
    });

    return;
  }
    let processedValue = value;
    if (name === "name" && value.length > NAME_MAX_LENGTH) {
      processedValue = value.slice(0, NAME_MAX_LENGTH);
    } else if (
      name === "description" &&
      value.length > DESCRIPTION_MAX_LENGTH
    ) {
      processedValue = value.slice(0, DESCRIPTION_MAX_LENGTH);
    }
    setFormData({
      ...formData,
      [name]: processedValue,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    // Required-empty fields set a `true` flag (red highlight only); invalid
    // values set the specific message string, which wins over the generic one
    if (!formData.name?.trim()) {
      newErrors.name = true;
    } else if (formData.name.trim().length < 2) {
      newErrors.name = t("coupons.nameMinLength");
    }
    if (!formData.category) newErrors.category = true;
    if (!formData.price) {
      newErrors.price = true;
    } else if (isNaN(formData.price) || Number(formData.price) <= 0) {
      newErrors.price = t("inventory.priceValidNumber");
    }
    if (!formData.description) newErrors.description = true;
    // if (!formData.allergyInfo) newErrors.allergyInfo = 'AllergyInfo is required.';

    // Ensure at least one dietary preference is selected
    const isAnyDietarySelected = Object.values(dietaryPreferences).some(
      (value) => value,
    );
    if (!isAnyDietarySelected) {
      newErrors.tags = t("inventory.Atleastone");
    }

    // If heatOption is true, heatTime must be provided
    if (heatOption && !formData.heatTime) {
      newErrors.heatTime = true;
    }

    setErrors(newErrors);
    // Show one message only: a specific error (name too short, invalid price)
    // wins over the generic "please fill" fallback; tags is excluded because
    // it already renders inline below the checkboxes
    const { tags: _tagsError, ...restErrors } = newErrors;
    const specificError = Object.values(restErrors).find(
      (v) => typeof v === "string",
    );
    setGeneralError(
      Object.keys(newErrors).length === 0
        ? ""
        : specificError || t("inventory.Pleasefillrequired"),
    );
    return Object.keys(newErrors)?.length === 0;
  };

  // Re-run validation on language switch so visible messages re-translate
  // (they are stored in state as already-translated strings)
  useEffect(() => {
    if (Object.keys(errors).length > 0) validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  const resetForm = () => {
    setFormData({
      name: "",
      category: "",
      description: "",
      price: "",
      heatOption: false,
      heatTime: "",
      allergyInfo: "",
      tags: [],
    });

    setErrors({});
    setGeneralError("");
    setImageFile(null);
    setImagePreview(null);
    setHeatOption(false);

    setDietaryPreferences({
      vegetarian: false,
      vegan: false,
      fishFree: false,
      glutenFree: false,
      lactoseFree: false,
      highProtein: false,
      notSpecified: false,
    });
  };

  const handleClose = () => {
    resetForm();
    onClose(); // closes the dialog
  };
  const handleSave = async () => {
    if (!validateForm()) return;

    try {
      // Ensure heatOption is correctly included in formData
      const updatedFormData = {
        ...formData,
        heatOption: heatOption, // Sync heatOption value
      };
      // Create FormData object
      const formDataToSend = new FormData();
      formDataToSend.append("json", JSON.stringify(updatedFormData));
      if (imageFile) formDataToSend.append("file", imageFile);

      setIsLoading(true);
      if (selectedProduct) {
        // Update the product
        await updateProduct(selectedProduct.productId, formDataToSend);
      } else {
        // Add a new product
        await addProduct(formDataToSend);
      }
      setSuccessNotification(true);
      onClose();
      // For updates: just refresh current view without navigating to new category
      // For new products: navigate to the new category
      if (selectedProduct) {
        if (onProductUpdated) onProductUpdated();
      } else {
        fetchProductsByCategory(formData.category);
      }

      // Reset the form
      setFormData({
        name: "",
        category: "",
        description: "",
        price: "",
        heatOption: false,
        heatTime: null,
        allergyInfo: "",
        tags: [],
      });
      setHeatOption(false);
      setDietaryPreferences({
        vegetarian: false,
        vegan: false,
        fishFree: false,
        glutenFree: false,
        lactoseFree: false,
        highProtein: false,
        notSpecified: false,
      });
      setImageFile(null);
      setImagePreview(null);
    } catch (error) {
      setGeneralError(error?.response?.data?.detail);
      console.error(t("inventory.errorMessageExistName"), error);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle Image Selection
  const handleImageUpload = (event) => {
    setImageError(false);
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      const validImageTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/gif",
      ];
      if (!validImageTypes.includes(file.type)) {
        setErrors({ ...errors, image: t("inventory.validImageFile") });
        return;
      }
      // Validate file size (limit to 2MB)
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      if (file.size > maxSize) {
        setErrors({ ...errors, image: t("inventory.fileSizeLimit") });
        setToastMessage(t("inventory.fileSizeLimit"));
        setOpen1(true); // Show toast
        return;
      }

      // Generate image preview
      const reader = new FileReader();
      reader.onload = () => {
        setImagePreview(reader.result); // Set the image preview
        setErrors({ ...errors, image: "" }); // Clear image errors
      };
      reader.readAsDataURL(file);
      setImageFile(file);
    }
  };

  useEffect(() => {
    if (!open) {
      setErrors({});
      setGeneralError("");
      setImageError(false);
      setOpen1(false);
    }
  }, [open]);

  return (
    <>
      {isLoading && <LoadingAnimation />}
      <Dialog
        className="inventory-product-sec"
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
        PaperProps={{
          sx: {
            position: "absolute",
            right: 10,
            margin: 0,
            // height: '100vh', // Full height
            borderRadius: 3,
            background: modalBackgrounColor,
          },

          "@media (max-width: 427px)": {
            right: 5,
            width: "97% !important",
          },
        }}
      >
        {/* Title with Close Icon */}
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: {
              xs: 2, // base padding
              sm: 3, // small screens
              md: "20px 24px ",
            },
          }}
        >
          <span className="franchise-heading-text">
            {selectedProduct
              ? t("inventory.editProduct")
              : t("inventory.addProduct")}
          </span>
          <IconButton onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            paddingTop: 2,
            p: {
              xs: 2, // base padding
              sm: 3, // small screens
              md: "20px 24px ",
            },
            marginRight: 1,
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: "8px !important",
              height: "8px !important",
              padding: "2px !important",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: scroll1,
              borderRadius: "10px",
              border: `1px solid ${scroll}`,
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: scroll,
              borderRadius: "10px",
              width: "3px !important",
              border: "3px solid transparent",
              backgroundClip: "padding-box",
              "&:hover": {
                backgroundColor: scroll,
              },
            },
          }}
        >
          <Box
            sx={
              {
                // p: {
                //   xs: 2, // base padding
                //   sm: 3, // small screens
                //   md: "20px 24px ",
                // } ,
                // '&::-webkit-scrollbar': {
                //   width: '8px !important',
                //   height: '8px !important',
                //   padding: '2px !important',
                // },
                // '&::-webkit-scrollbar-track': {
                //   backgroundColor: scroll1,
                //   borderRadius: '10px',
                //   border: `1px solid ${scroll}`,
                // },
                // '&::-webkit-scrollbar-thumb': {
                //   backgroundColor: scroll,
                //   borderRadius: '10px',
                //   width: '3px !important',
                //   border: '3px solid transparent',
                //   backgroundClip: 'padding-box',
                //   '&:hover': {
                //     backgroundColor: scroll,
                //   },
                // },
              }
            }
          >
            <Box
              component="form"
              noValidate
              autoComplete="off"
              sx={{ display: "flex", flexDirection: "column", gap: 3 }}
            >
              {/* Image Upload */}
              <Box
                sx={{
                  border: `1px dashed ${imgBoxColor}`,
                  borderRadius: "8px",
                  textAlign: "center",
                  cursor: "pointer",
                  position: "relative",
                  width: "100%",
                  height: "300px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
                onClick={() => document.getElementById("upload-image").click()}
              >
                <input
                  type="file"
                  id="upload-image"
                  style={{ display: "none" }}
                  accept="image/*"
                  onChange={handleImageUpload}
                />
                {imagePreview && !imageError ? (
                  <img
                    src={imagePreview}
                    alt="Preview"
                    onError={() => setImageError(true)}
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                    }}
                  />
                ) : (
                  <div>
                    <AddPhotoAlternateIcon
                      sx={{
                        fontSize: "8rem",
                        color: "#C6C6C6",
                      }}
                    />
                    <Typography sx={{ color: imgBoxColor }}>
                      {t("inventory.uploadImage")}
                      <br />
                      {t("inventory.uploadImage1")} 500×320 px
                      <br />
                      {t("inventory.uploadImage2")} (1000×640 px)
                    </Typography>
                  </div>
                )}
              </Box>

              {/* Name Fields */}
              <Box>
                <StyledTextField
                  label={`${t("inventory.nameoftheProduct")}`}
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  error={errors.name || isNameAtLimit}
                  inputBoxColor={inputBoxColor}
                  required
                />
                {/* {errors.name && (
                <Typography
                  color="error"
                  variant="body2"
                  sx={{ marginTop: 0.5, marginLeft: 0, fontSize: "13px" }}
                >
                  {errors.name}
                </Typography>
              )}  */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    mt: 1,
                    minHeight: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      color: isNameAtLimit
                        ? counterErrorColor
                        : isNameWarning
                          ? counterWarningColor
                          : counterNormalColor,
                      fontSize: "12px",
                    }}
                  >
                    {t("inventory.charCount", {
                      count: nameCharCount,
                      limit: NAME_MAX_LENGTH,
                    })}
                  </Typography>
                  {isNameAtLimit && (
                    <Typography
                      variant="caption"
                      sx={{ color: counterErrorColor, ml: 1, fontSize: "12px" }}
                    >
                      {t("inventory.charLimitReached")}
                    </Typography>
                  )}
                </Box>
              </Box>

              {/* Select Category with Search */}
              <Box>
                <Autocomplete
                  options={categoryList}
                  getOptionLabel={(option) => option.name}
                  value={
                    categoryList.find((cat) => cat.id === formData.category) ||
                    null
                  }
                  onChange={(event, newValue) => {
                    setFormData({
                      ...formData,
                      category: newValue ? newValue.id : "",
                    });
                  }}
                  filterOptions={(options, state) => {
                    const inputValue = state.inputValue;
                    if (!inputValue.trim()) return options;

                    const searchQueryLower = inputValue.toLowerCase().trim();

                    const filtered = options.filter((option) => {
                      const categoryName = option.name.toLowerCase();

                      // Strategy 1: Try exact match with the full search query without spaces
                      const categoryNameNoSpaces = categoryName.replace(
                        /\s+/g,
                        "",
                      );
                      const searchQueryNoSpaces = searchQueryLower.replace(
                        /\s+/g,
                        "",
                      );
                      if (categoryNameNoSpaces.includes(searchQueryNoSpaces))
                        return true;

                      // Strategy 2: Try matching with spaces in search query
                      if (categoryName.includes(searchQueryLower)) return true;

                      // Strategy 3: Split search terms and require all to be present
                      const searchTerms = searchQueryLower.split(/\s+/);
                      return searchTerms.every((term) =>
                        categoryName.includes(term),
                      );
                    });

                    return filtered;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={`${t("inventory.selectCategory")}`}
                      error={!!errors.category}
                      required
                      variant="filled"
                      InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                      }}
                      sx={{
                        backgroundColor: inputBoxColor,
                        borderRadius: "6px",
                        "& .MuiFilledInput-root": {
                          backgroundColor: inputBoxColor,
                          borderRadius: "6px",
                          "&:hover": { backgroundColor: inputBoxColor },
                          "&.Mui-focused": { backgroundColor: inputBoxColor },
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option, { inputValue }) => {
                    // Highlight matching text using multiple strategies
                    const highlightText = (text, query) => {
                      if (!query.trim()) return text;

                      const searchQueryLower = query.toLowerCase().trim();
                      const lowerText = text.toLowerCase();

                      // Find all matching positions using multiple strategies
                      const matches = [];

                      // Strategy 1: Match full query without spaces
                      const textNoSpaces = lowerText.replace(/\s+/g, "");
                      const queryNoSpaces = searchQueryLower.replace(
                        /\s+/g,
                        "",
                      );
                      if (queryNoSpaces.length > 0) {
                        let startIndex = 0;
                        while (true) {
                          const index = textNoSpaces.indexOf(
                            queryNoSpaces,
                            startIndex,
                          );
                          if (index === -1) break;
                          // Map back to original positions (accounting for removed spaces)
                          let originalStart = 0;
                          let spaceCount = 0;
                          for (let i = 0; i < index; i++) {
                            if (lowerText[originalStart] === " ") spaceCount++;
                            originalStart++;
                          }
                          const originalEnd =
                            originalStart + queryNoSpaces.length + spaceCount;
                          matches.push({
                            start: originalStart,
                            end: Math.min(originalEnd, text.length),
                          });
                          startIndex = index + 1;
                        }
                      }

                      // Strategy 2: Match full query with spaces
                      if (searchQueryLower.length > 0) {
                        let startIndex = 0;
                        while (true) {
                          const index = lowerText.indexOf(
                            searchQueryLower,
                            startIndex,
                          );
                          if (index === -1) break;
                          matches.push({
                            start: index,
                            end: index + searchQueryLower.length,
                          });
                          startIndex = index + 1;
                        }
                      }

                      // Strategy 3: Match individual terms
                      const searchTerms = searchQueryLower
                        .split(/\s+/)
                        .filter((term) => term.length > 0);
                      searchTerms.forEach((term) => {
                        let startIndex = 0;
                        while (true) {
                          const index = lowerText.indexOf(term, startIndex);
                          if (index === -1) break;
                          matches.push({
                            start: index,
                            end: index + term.length,
                          });
                          startIndex = index + 1;
                        }
                      });

                      // Sort and merge overlapping matches
                      matches.sort((a, b) => a.start - b.start);
                      const mergedMatches = [];
                      for (const match of matches) {
                        if (
                          mergedMatches.length === 0 ||
                          match.start >
                            mergedMatches[mergedMatches.length - 1].end
                        ) {
                          mergedMatches.push({ ...match });
                        } else {
                          mergedMatches[mergedMatches.length - 1].end =
                            Math.max(
                              mergedMatches[mergedMatches.length - 1].end,
                              match.end,
                            );
                        }
                      }

                      // Build highlighted result
                      let result = [];
                      let lastIndex = 0;
                      for (const match of mergedMatches) {
                        if (match.start > lastIndex) {
                          result.push(text.substring(lastIndex, match.start));
                        }
                        result.push(
                          <strong key={match.start}>
                            {text.substring(match.start, match.end)}
                          </strong>,
                        );
                        lastIndex = match.end;
                      }

                      if (lastIndex < text.length) {
                        result.push(text.substring(lastIndex));
                      }

                      return result.length > 0 ? result : text;
                    };

                    return (
                      <MenuItem {...props} key={option.id}>
                        {highlightText(option.name, inputValue)}
                      </MenuItem>
                    );
                  }}
                  noOptionsText={t("inventory.noMatchingCategories")}
                  disablePortal
                  clearOnBlur={false}
                  handleHomeEndKeys
                />
                {/* {errors.category && (
                <Typography
                  color="error"
                  variant="body2"
                  sx={{ marginTop: 0.5, marginLeft: 2 }}
                >
                  {errors.category}
                </Typography>
              )} */}
              </Box>

              {/* Price */}
              <Box>
                <StyledTextField
                  label={`${t("inventory.priceoftheProduct")} (€)`}
                  name="price"
                  numberType="true"
                  inputProps={{ min: 1, onWheel: (e) => e.target.blur() }}
                  value={formData.price}
                  onChange={handleChange}
                  error={errors.price}
                  inputBoxColor={inputBoxColor}
                  required
                />
              </Box>

              {/* Heat Option */}
              <Box
                sx={{
                  backgroundColor: inputBoxColor,
                  borderRadius: 2,
                  padding: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="body2" sx={{ fontSize: "15px" }}>
                    {t("inventory.heatuptheproduct")}
                  </Typography>
                  <Switch
                    checked={heatOption}
                    onChange={handleToggleHeatOption}
                    name="heatOption"
                    color="primary"
                  />
                </Box>
                {heatOption && (
                  <StyledTextField
                    label={`${t("inventory.heatTime")}`}
                    name="heatTime"
                    value={formData.heatTime}
                    onChange={handleChange}
                    error={errors.heatTime}
                    inputBoxColor={modalBackgrounColor}
                    required
                  />
                )}
              </Box>

              {/* Dietary Preferences */}
              <Box
                sx={{
                  backgroundColor: inputBoxColor,
                  borderRadius: 2,
                  padding: 2,
                }}
              >
                <p
                  className="placeholder-text"
                  style={{ color: inputTextColor }}
                >
                  {t("inventory.dietaryPreferences")} *
                </p>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: isMobile ? 1 : 2,
                  }}
                >
                  {tags.map((tag, index) => {
                    const dietaryKey = tag.key;
                    return (
                      <FormControlLabel
                        key={index}
                        style={{ color: inputTextColor }}
                        control={
                          <Checkbox
                            checked={dietaryPreferences[dietaryKey] || false}
                            onChange={handleDietaryPreferenceChange}
                            name={dietaryKey}
                          />
                        }
                        label={tag.label}
                      />
                    );
                  })}
                </Box>
                {errors.tags && (
                  <Typography
                    color="error"
                    variant="body2"
                    sx={{ marginTop: 1 }}
                  >
                    {errors.tags}
                  </Typography>
                )}
              </Box>

              {/* Description */}
              <Box>
                <TextField
                  label={`${t("inventory.description")}`}
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  error={errors.description || isDescAtLimit}
                  type="text"
                  variant={"filled"}
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: DESCRIPTION_MAX_LENGTH }}
                  multiline
                  rows={2}
                  maxRows={4}
                  fullWidth
                  sx={{
                    backgroundColor: inputBoxColor,
                    borderRadius: "6px",
                    "& .MuiFilledInput-root": {
                      backgroundColor: inputBoxColor,
                      borderRadius: "6px",
                      "&:hover": { backgroundColor: inputBoxColor },
                      "&.Mui-focused": { backgroundColor: inputBoxColor },
                    },
                  }}
                  required
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    mt: 0.5,
                    px: 1,
                    minHeight: "20px",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      color: isDescAtLimit
                        ? counterErrorColor
                        : isDescWarning
                          ? counterWarningColor
                          : counterNormalColor,
                      fontSize: "12px",
                    }}
                  >
                    {t("inventory.charCount", {
                      count: descCharCount,
                      limit: DESCRIPTION_MAX_LENGTH,
                    })}
                  </Typography>
                  {isDescAtLimit && (
                    <Typography
                      variant="caption"
                      sx={{ color: counterErrorColor, ml: 1, fontSize: "12px" }}
                    >
                      {t("inventory.charLimitReached")}
                    </Typography>
                  )}
                </Box>
              </Box>

              {/* Allergen */}
              <Box>
                <TextField
                  label={`${t("inventory.allergen")}`}
                  name="allergyInfo"
                  value={formData.allergyInfo}
                  onChange={handleChange}
                  error={errors.allergyInfo}
                  type="text"
                  variant={"filled"}
                  InputProps={{ disableUnderline: true }}
                  multiline
                  rows={3}
                  fullWidth
                  sx={{
                    backgroundColor: inputBoxColor,
                    borderRadius: "6px",
                    "& .MuiFilledInput-root": {
                      backgroundColor: inputBoxColor,
                      borderRadius: "6px",
                      "&:hover": { backgroundColor: inputBoxColor },
                      "&.Mui-focused": { backgroundColor: inputBoxColor },
                    },
                  }}
                />
              </Box>

              {generalError && (
                <Typography
                  color="error"
                  variant="body2"
                  sx={{ textAlign: "center", marginTop: 1 }}
                >
                  {generalError}
                </Typography>
              )}

              {/* Action Buttons */}
              {selectedProduct ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <button
                    type="button"
                    style={{ color: deleteColor, borderColor: deleteColor }}
                    className="cancel-btn"
                    onClick={handleDeleteClick}
                  >
                    {t("membershipCards.delete")}
                  </button>
                  <Box style={{ display: "flex", gap: 10 }}>
                    <button
                      type="button"
                      style={{ color: btnColor, borderColor: btnColor }}
                      className="cancel-btn"
                      onClick={handleClose}
                    >
                      {t("membershipCards.cancel")}
                    </button>
                    <button
                      type="button"
                      style={{ background: btnColor }}
                      className="save-btn"
                      onClick={handleSave}
                    >
                      {t("membershipCards.save")}
                    </button>
                  </Box>
                </Box>
              ) : (
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}
                >
                  <button
                    type="button"
                    style={{ color: btnColor, borderColor: btnColor }}
                    className="cancel-btn"
                    onClick={onClose}
                  >
                    {t("membershipCards.cancel")}
                  </button>
                  <button
                    type="button"
                    style={{ background: btnColor }}
                    className="save-btn"
                    onClick={handleSave}
                  >
                    {t("membershipCards.save")}
                  </button>
                </Box>
              )}
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Use Notification Component */}
      <SuccessNotification
        open={successNotification}
        message={t(
          selectedProduct
            ? "membershipCards.successMessage"
            : "inventory.productSuccessMessage",
        )}
        severity="success"
        onClose={() => setSuccessNotification(false)}
      />

      {/* // Snackbar component */}
      <Snackbar
        open={open1}
        autoHideDuration={4000} // Auto hide after 3 seconds
        onClose={() => setOpen1(false)} // Close the Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }} // Position the Snackbar at the top center
      >
        <Alert
          onClose={() => setOpen1(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {toastMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default ProductModal;
